/**
 * Upper limit for duration formatting in milliseconds (10 seconds)
 */
export const DURATION_UPPER_LIMIT_MS = 10_000;

/**
 * Latency objectives and thresholds for monitoring
 */
export const P50_LATENCY_OBJECTIVE_MS = 250;
export const P50_LATENCY_WARNING_MS = 300;
export const P50_LATENCY_CRITICAL_MS = 500;
export const P95_LATENCY_OBJECTIVE_MS = 500;
export const P95_LATENCY_WARNING_MS = 600;
export const P95_LATENCY_CRITICAL_MS = 1_000;
export const P99_LATENCY_OBJECTIVE_MS = 750;
export const P99_LATENCY_WARNING_MS = 900;
export const P99_LATENCY_CRITICAL_MS = 1_500;